module.exports = __webpack_public_path__ + "static/img/vod-bn-3.7f0bce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-3.jpg
// module id = KQd6
// module chunks = 1